// extracted by mini-css-extract-plugin
module.exports = {"message":"widget-demo--message--3cuHa","title":"widget-demo--title--3zU6v"};